export var grid = {
  none: 0,
  xsmall: 8,
  small: 16,
  medium: 24,
  large: 32,
  xlarge: 40,
  xxlarge: 80
};
export var borderRadius = {
  small: 2,
  medium: 3,
  large: 6
};
export var breakpoints = {
  xsmall: 416,
  small: 768,
  medium: 1024,
  large: 1440,
  xlarge: 1920
};
export var mediaQueries = Object.values(breakpoints).map(function (bp) {
  return "@media(min-width: ".concat(bp, "px)");
});